import Field from "../../../Components/Field";
import RadioInput from "../RadioInput";

const Notify = ({ configs, onChange }) => {
  return (
    <>
      <div className="phishbox-settings__line">
        <RadioInput
          label="Enable Email Notifications*"
          tooltipText="Flag to enable or disable mail notification controls."
          name="notify.enabled"
          value={configs.notify.enabled}
          onChange={onChange}
        />
      </div>
      <div className="phishbox-settings__line">
        <div className="p-r-20">
          <Field
            label="Server*"
            tooltipText="Address of the notification mail server."
            width="188px"
            name="notify.server"
            value={configs.notify.server}
            onChange={onChange}
            placeholder="smtp.example.com"
            disabled={configs.notify.enabled === 0}
          />
        </div>
        <Field
          label="Port*"
          tooltipText="Port number of the mail server."
          width="92px"
          type="number"
          name="notify.port"
          value={configs.notify.port}
          onChange={onChange}
          placeholder="587"
          disabled={configs.notify.enabled === 0}
        />
      </div>
      <div className="phishbox-settings__line">
        <div className="p-r-20">
          <Field
            label="Username*"
            tooltipText="Username for mail server authentication."
            width="188px"
            name="notify.username"
            value={configs.notify.username}
            onChange={onChange}
            placeholder="user@example.com"
            disabled={configs.notify.enabled === 0}
          />
        </div>
        <Field
          label="Password*"
          tooltipText="Password for mail server authentication."
          width="188px"
          name="notify.password"
          type="password"
          value={configs.notify.password}
          onChange={onChange}
          placeholder="********"
          disabled={configs.notify.enabled === 0}
        />
      </div>
      <div className="phishbox-settings__line">
        <Field
          label="Company*"
          tooltipText="Company name to be displayed in notifications."
          width="318px"
          name="notify.company"
          value={configs.notify.company}
          onChange={onChange}
          placeholder="My Company"
          disabled={configs.notify.enabled === 0}
        />
      </div>
      <div className="phishbox-settings__line">
        <Field
          label="Short (Subject)*"
          tooltipText="Short subject line for the notification email."
          width="318px"
          name="notify.short"
          value={configs.notify.short}
          onChange={onChange}
          placeholder="Malicious Link Clicked !"
          disabled={configs.notify.enabled === 0}
        />
      </div>
      <div className="phishbox-settings__line">
        <Field
          label="CIRT Email*"
          tooltipText="Email address of the CIRT/SOC team to receive notifications."
          width="318px"
          name="notify.cirtemail"
          value={configs.notify.cirtemail}
          onChange={onChange}
          placeholder="cirt@example.com"
          disabled={configs.notify.enabled === 0}
        />
      </div>
      <div className="phishbox-settings__line">
        <RadioInput
          label="Use TLS*"
          name="notify.tls"
          tooltipText="Enable TLS encryption for mail server connection."
          value={configs.notify.tls}
          onChange={onChange}
          disabled={configs.notify.enabled === 0}
        />
      </div>
    </>
  );
};

export default Notify;
